import { useContext, useMemo } from "react";
import { Clara2MessageStreamHandler } from "../../../../../features/ai-chatbot/utils/clara-2-message-stream-handler";
import { useIsClara2Available } from "../../../../../hooks/feature-flags/useIsClara2Available/useIsClara2Available";
import { ChatbotContext } from "../../chatbot.context";
import { ChatbotMediator } from "../../lib/mediator/chatbot.mediator";
import type { IChatbotMediator } from "../../lib/mediator/chatbot.mediator.interface";
import { ChatbotDispatcherService } from "../../lib/services/chatbot-dispatcher/chatbot.dispatcher.service";

export function useChatbotMediator(): IChatbotMediator {
  const { dispatch } = useContext(ChatbotContext);
  const isClara2Available = useIsClara2Available();

  const chatbotMediator = useMemo(
    function createChatbotMediator() {
      const dispatcherService = new ChatbotDispatcherService(dispatch);

      if (isClara2Available) {
        return new ChatbotMediator(dispatcherService, new Clara2MessageStreamHandler(dispatcherService));
      }

      return new ChatbotMediator(dispatcherService);
    },
    [dispatch, isClara2Available]
  );

  return chatbotMediator;
}
